export default __webpack_public_path__ + "static/media/godaddy-logo.59cdb6c9.svg";